<template>
    <el-form ref="form" :model="form" label-width="80px" style="margin-top: 30px">
        <div align="center">


            <el-button-group>
                <el-button v-if="this.form.radio === '服务进度'" plain
                           style="background:orange; color: white; border-color: orange" size="mini"
                           @click.stop="onClick1">服务进度
                </el-button>
                <el-button v-else-if="this.form.radio !== '服务进度'" plain
                           style="color: orange; background: white; border-color: orange" size="mini"
                           @click.stop="onClick1">服务进度
                </el-button>
                <!--<el-button v-if="this.form.radio === '与门店的沟通'" plain-->
                           <!--style="background: orange;color: white; border-color: orange" size="mini"-->
                           <!--@click.stop="onClick2">与门店的沟通-->
                <!--</el-button>-->
                <!--<el-button v-else-if="this.form.radio !== '与门店的沟通'" plain-->
                           <!--style="color: orange; background: white; border-color: orange" size="mini"-->
                           <!--@click.stop="onClick2">与门店的沟通-->
                <!--</el-button>-->
                <el-button v-if="this.form.radio === '与服务人员的沟通'" plain
                           style="background: orange;color: white; border-color: orange" size="mini"
                           @click.stop="onClick3">与服务人员的沟通
                </el-button>
                <el-button v-else-if="this.form.radio !== '与服务人员的沟通'" plain
                           style="color: orange; background: white;  border-color: orange" size="mini"
                           @click.stop="onClick3">与服务人员的沟通
                </el-button>
            </el-button-group>
        </div>
        <div style="margin-left: 40px; width: 320px; margin-top: 20px">


            <div v-show="form.radio === '服务进度'">
                <el-row>
                    <el-col :span="2">
                        <div v-for="(item, index) in form.stepDatas" :key="index" :label="item" :span="8">
                            <div style=" height: 80px" align="center">
                                <!--border-radius: 15px; #-->
                                <div v-if="index==0"
                                     style=" border-radius: 10px; height: 20px; width: 20px;background-color:limegreen; margin-top: 3px"></div>
                                <div v-if="index==0"
                                     style="border-radius: 8px; margin-top: -18px; height: 16px; width: 16px;background-color:#E9EEF3 "></div>
                                <div v-if="index==0"
                                     style="border-radius: 6px; margin-top: -14px; height: 12px; width: 12px;background-color:limegreen "></div>
                                <div v-if="index!=0"
                                     style="border-radius: 6px; height: 12px; width: 12px;background-color:lightgray;"></div>
                                <div v-if="index==0"
                                     style="margin-top: 4px; width:3px;min-height: 80px; background-color:lightgray;overflow:hidden;"></div>
                                <div v-if="index!=0"
                                     style="margin-top: -6px; width:3px;min-height: 80px; background-color:lightgray;overflow:hidden;"></div>
                            </div>
                        </div>

                    </el-col>
                    <el-col :span="22">
                        <div v-for="(item, index) in form.stepDatas" :key="index" :label="item" :span="8"
                             style=" height: 80px" align="left">
                            <div v-if="index==0"
                                 style="margin-left: 10px; margin-top: 5px; font-size: 14px; color: limegreen">
                                {{item.content}}
                            </div>
                            <div v-if="index==0"
                                 style="margin-left: 10px; margin-top: 10px; font-size: 8px; color: limegreen">
                                {{item.timestamp}}
                            </div>
                            <div v-if="index!=0"
                                 style="margin-left: 10px; margin-top: -2px; font-size: 14px; color: lightgray">
                                {{item.content}}
                            </div>
                            <div v-if="index!=0"
                                 style="margin-left: 10px; margin-top: 10px; font-size: 8px; color: lightgray">
                                {{item.timestamp}}
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!--<div v-show="form.radio === '与门店的沟通'" align="center">-->
                <!--<el-button size="mini" style="width: 310px; margin-left: -20px; background-color: orange; color: white"-->
                           <!--@click.stop="showRetailMsg">写一笔-->
                <!--</el-button>-->

                <!--<div style="margin-bottom: 10px; margin-top: 10px; margin-left: -20px; width: 340px; background-color: white "-->
                     <!--v-for="dataObj in form.retailDatas" align="left">-->
                    <!--<el-row :gutter="24">-->
                        <!--<el-col :span="3">-->
                            <!--<div style="height: 50px;">-->
                                <!--<img :src="chatHeader" width="30px" height="30px"-->
                                     <!--style="margin-top: 10px; margin-left: 10px"/>-->
                            <!--</div>-->
                        <!--</el-col>-->
                        <!--<el-col :span="21">-->
                            <!--<div style="min-height: 20px; font-size: 12px; color: lightgray; margin-top: 10px">-->
                                <!--{{dataObj.alias}}-->
                            <!--</div>-->
                            <!--<div style="min-height:20px; font-size: 12px; color: lightgray; ">-->
                                <!--<img width="12px"-->
                                     <!--height="12px"-->
                                     <!--:src="time"-->
                                     <!--alt="">{{dataObj.time}}-->
                            <!--</div>-->
                            <!--<div style="min-height:20px; font-size: 12px; color: lightgray; ">{{dataObj.msg}}</div>-->
                            <!--<div v-show="dataObj.photos.length > 0" v-for="(image, index) in dataObj.photos">-->
                                            <!--<span><img :src="image.url" width="80px" height="80px"-->
                                                       <!--style=" margin-bottom: 10px; float: left;margin-left: 10px"-->
                                                       <!--@click="dialogVisibles(image.url)"/></span>-->
                            <!--</div>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                <!--</div>-->

            <!--</div>-->


            <div v-show="form.radio === '与服务人员的沟通'" align="center">
                <el-button size="mini" style="width: 310px; margin-left: -20px; background-color: orange; color: white"
                           @click.stop="showServiceMsg">写一笔
                </el-button>
                <div style="margin-bottom: 10px; margin-top: 10px; margin-left: -20px; width: 340px; background-color: white "
                     v-for="dataObj in form.serviceDatas" align="left">
                    <el-row :gutter="24">
                        <el-col :span="3">
                            <div style="height: 50px;">
                                <img :src="chatHeader" width="30px" height="30px"
                                     style="margin-top: 10px; margin-left: 10px"/>
                            </div>
                        </el-col>
                        <el-col :span="21">
                            <div style="min-height: 20px; font-size: 12px; color: lightgray; margin-top: 10px">
                                {{dataObj.alias}}
                            </div>
                            <div style="min-height:20px; font-size: 12px; color: lightgray; ">
                                <img width="12px"
                                     height="12px"
                                     :src="time"
                                     alt="">{{dataObj.time}}
                            </div>
                            <div style="min-height:20px; font-size: 12px; color: lightgray; ">{{dataObj.msg}}</div>
                            <div v-show="dataObj.photos.length > 0" v-for="(image, index) in dataObj.photos">
                                            <span><img :src="image.url" width="80px" height="80px"
                                                       style=" margin-bottom: 10px; float: left;margin-left: 10px"
                                                       @click="dialogVisibles(image.url)"/></span>
                            </div>
                        </el-col>
                    </el-row>
                </div>

            </div>

        </div>

    </el-form>
</template>

<script>
    import http from '../../../APIService/http'
    import phone from '../../../assets/images/phone.png'
    import chatHeader from '../../../assets/images/chat_header_image.png'
    import greengou from '../../../assets/images/green-gou.png'
    import time from '../../../assets/images/time.png'

    export default {
        props: {},
        components: {},
        data() {
            return {
                time: time,
                phone: phone,
                greengou: greengou,
                chatHeader: chatHeader,
                form: {
                    radio: '服务进度',
                    stepDatas: [],
                    retailDatas: [],
                    serviceDatas: []
                }
            }
        },
        computed: {},
        created() {

        },
        methods: {

            addRetailDatas(data) {
                this.form.retailDatas.splice(0, 0, data)
            },
            setRetailDatas(data) {
                this.form.retailDatas = data
            },

            addServiceDatas(data) {
                this.form.serviceDatas.splice(0, 0, data)
            },
            setServiceDatas(data) {
                this.form.serviceDatas = data
            },

            setStepDatas(data) {
                this.form.stepDatas = data
            },

            showRetailMsg(){
                var obj = {}
                obj.showMsg = true
                obj.msg = ''
                obj.photos = []
                obj.fileList = []
                obj.type = "RETAIL"

                this.$emit('sendMessage', obj)

            },
            showServiceMsg(){
                var obj = {}
                obj.showMsg = true
                obj.msg = ''
                obj.photos = []
                obj.fileList = []
                obj.type = "SERVICE"
                this.$emit('sendMessage', obj)

            },




//            info(index, row) {
//                this.$router.push({
//                    path: '/workOrderInfo',
////                    query: {
////                        type: 1,
////                        ticket_id: row.ticket_id,
////                        store_name: row.store_name,
////                        address: row.address
////                    }
//                })
//            },
            onClick1() {
                if (this.form.radio !== '服务进度') {
                    this.form.radio = '服务进度'
//                    this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    if (this.listServiceSheet == null){
//                        this.$store.commit('resetListServiceSheet')
//                        this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    }
//                    this.listServiceSheet.radio = '待接单和派单中'
//                    this.init()
                }
            },
            onClick2() {
                if (this.form.radio !== '与门店的沟通') {
                    this.form.radio = '与门店的沟通'
//                    this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    if (this.listServiceSheet == null){
//                        this.$store.commit('resetListServiceSheet')
//                        this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    }
//                    this.listServiceSheet.radio = '进行中的工单'
//                    this.init()
                }
            },
            onClick3() {
                if (this.form.radio !== '与服务人员的沟通') {
                    this.form.radio = '与服务人员的沟通'
//                    this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    if (this.listServiceSheet == null){
//                        this.$store.commit('resetListServiceSheet')
//                        this.listServiceSheet = this.$store.getters.getListServiceSheet
//                    }
//                    this.listServiceSheet.radio = '订单查询'
//                    this.init()
                }
            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';


</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/segment/segment.vue